export const LOAD_INSIGHTS = 'LOAD_INSIGHTS';
export const CLEAR_INSIGHTS = 'CLEAR_INSIGHTS';
